export default __webpack_public_path__ + "static/media/Logo-Horizontal.ea6cf6bb.svg";